export const makeArrayWithLength = (length: number) => {
  const arr = Array.from({ length }, (_, i) => i)

  return arr
}
